// extracted by mini-css-extract-plugin
export default {"count-button":"CountButton_count-button__9ZpQp"};